var map = {
	"./de/triangle-icon.png": "5yPF",
	"./en/triangle-icon.png": "6kSc",
	"./es/triangle-icon.png": "APGe",
	"./fr/triangle-icon.png": "0ZYj",
	"./ja/triangle-icon.png": "VRD1",
	"./ko/triangle-icon.png": "m5Ug",
	"./pt/triangle-icon.png": "J9Ll",
	"./ru/triangle-icon.png": "KyA8",
	"./tc/triangle-icon.png": "kjMP",
	"./th/triangle-icon.png": "PsDx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1Yi5";